// extracted by mini-css-extract-plugin
export var artwork = "section_hero_wrapper-module--artwork--mJHHv";
export var artworkWrapper = "section_hero_wrapper-module--artworkWrapper--3sQQ1";
export var copyWrapper = "section_hero_wrapper-module--copyWrapper--KMNpK";
export var heroWrapper = "section_hero_wrapper-module--heroWrapper--ufnA7";
export var isReversed = "section_hero_wrapper-module--isReversed--QBdOs";